import { Component, HostListener, OnInit } from '@angular/core';
import { PermissionsService } from './services/General/Permissions/permissions.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BreakpointSizes, orderedBreakpoints } from 'src/app/utils/Breakpoints';
import { PwaInstallService } from 'src/app/services/General/PWAInstall/pwainstall.service';
import { FullScreenService } from 'src/app/services/General/FullScreen/fullscreen.service';
import { AlertController } from '@ionic/angular';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {

  constructor(
    private readonly breakPointObserver: BreakpointObserver,
  ) {}


  ngOnInit(): void {
    this.breakPointObserver.observe([
      ...Object.values(BreakpointSizes).map((breakpoint) => breakpoint)
    ]).subscribe((result) => {
      for (const [breakpoint, fontSize] of orderedBreakpoints) {
        if (result.breakpoints[breakpoint]) {
          document.body.style.fontSize = fontSize;
          break;
        }
      }
    });
  }

}
